import React, { useEffect, useState } from 'react';
import './_dashboard.scss';
import ApiGo from '../../actions/ApiGo';
import { useDispatch, useSelector } from 'react-redux';
import { ADD_BEDS_ARRAY } from '../../stores/reducer_beds';
import CardDefault from './../card/CardDefault';

const Dashboard = React.memo((props) => {
    const sortDesc = props.sortDesc;
    const mos = props.mos
    const mos_events = mos?.events;
    const store_resident_array = useSelector(state => state.store_residents.orign_residents_array)
    const store_beds_array = useSelector(state => state.store_beds.beds_array)
    const dispatch = useDispatch()

    const [apiData_combine, setApiData_Combine] = useState(null);
    const [fetchCount, setFetchCount] = useState(0);

    useEffect(() => {
        ApiGo.getBed()
            .then(res => { dispatch(ADD_BEDS_ARRAY(res.beds)) })
            .catch(() => { })
    }, []);

    useEffect(() => {
        setFetchCount(0);
    }, [store_resident_array])

    useEffect(() => {
        let bedAndres_id = null;
        let apiGoResult2 = null;
        let combine_result = [];
        let result_residents = null;
        const fetchData = async () => {
            setFetchCount(1)

            bedAndres_id = store_beds_array
                .filter(e => e.resident_id !== null) //過濾目前沒有受護者在使用的智慧墊
                .map(e => [e.id, e.resident_id, e.alert_priority, e.alert_type_id, e.card_type, e.alert_ts]);

            result_residents = store_resident_array;

            //如果都沒有正在使用的智慧墊就return
            if (bedAndres_id.length === 0) { return }

            for (let i = 0; i < bedAndres_id.length; i++) {
                let _bed_id = bedAndres_id[i][0];
                let _res_id = bedAndres_id[i][1];
                let card_type = bedAndres_id[i][4];
                let setting_enter_array = [];

                result_residents.map((e) => {
                    setting_enter_array.push({ data: e })
                })
                apiGoResult2 = store_resident_array.filter(e => e.id === _res_id)[0]
                if (apiGoResult2 === undefined || apiGoResult2 === null) { continue }
                let _combien = {
                    ...apiGoResult2,
                    alert_priority: bedAndres_id[i][2] ?? "1",
                    alert_type_id: bedAndres_id[i][3] ?? "206",
                    alert_timestamp: bedAndres_id[i][5]
                }
                if (apiGoResult2.mac_left !== null && card_type === "aidc") {
                    _combien = {
                        ..._combien,
                        bed_id: _bed_id,
                        setting_params: apiGoResult2
                    }
                    combine_result.push({ data: _combien, card_type: card_type })
                } else {
                    card_type = "notAdic"
                    _combien = { ..._combien, bed_id: _bed_id }
                    combine_result.push({ data: _combien, card_type: card_type })
                }
            }
            setApiData_Combine(combine_result)
        };

        if (store_resident_array.length !== 0 && store_beds_array.length !== 0) {
            if (fetchCount === 0) { fetchData(); }
        }
    }, [apiData_combine, store_beds_array, store_resident_array, fetchCount]);

    useEffect(() => {
        let _new_beds_status = []
        if (apiData_combine !== null && mos_events !== null) {
            console.log('mos_events:', mos_events.bed_state);
            console.log('alert_level:', mos_events.alert_level);
            console.log('timestamp:', mos_events.timestamp);
            apiData_combine.forEach(beds => {
                if (mos_events.bed_id === beds.data.bed_id) {
                    beds.data.alert_type_id = mos_events.bed_state
                    beds.data.alert_priority = mos_events.alert_level
                    beds.data.alert_timestamp = mos_events.timestamp
                }
                _new_beds_status.push(beds)
            })
            console.log("查看_new_beds_status", _new_beds_status)
            setApiData_Combine(_new_beds_status)
        }
    }, [mos_events])

    let dashboard_header = ['BED_NO', 'NAME', '4_IN_BED_1', 'BREATH_TIMES', "SLEEP_QUALITY", 'AUTO', 'LOCK', 'BFRISE', 'FOOTRISE_30', '1_NO_IN_BED_1', 'MOTECKICON_LEFT', 'TURNOVER_TIMES', 'DIAPER_THROUGHT', 'DIAPER_WEIGHT']
    const isShowFeature = Array.from({ length: dashboard_header.length }, v => true);
    isShowFeature[3] = false;

    //排序方法
    function naturalCompare(a = "", b = "") {
        const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'base'
        });
        return collator.compare(String(a ?? ""), String(b ?? ""));
    }

    //姓名排序
    const sortedData = apiData_combine
        ? [...apiData_combine].sort((a, b) => {
            const result = naturalCompare(a.data.first_name, b.data.first_name);
            return sortDesc ? -result : result;
        })
        : null;

    return (
        <div className="wrap-dashboard font-m">
            <div className="fx-wrap">
                {
                    //sortedData的每一項
                    sortedData
                        ? sortedData.map((data, index) =>
                            <div id={`apiData_combine-${index}`}
                                key={`apiData_combine-${index}`}
                                className="col-sm-1 m-1">
                                <CardDefault data={data} mos={mos} />
                            </div>
                        )
                        : null
                }
            </div>
        </div>
    )
})

export default Dashboard;